import styled from "styled-components";
import { NavLink as Link } from 'react-router-dom';
import { FaBars } from 'react-icons/fa';

export const Nav = styled.nav`
    background-color: rgba(33, 35, 38,0.96);
    /* height: ${props => props.height}; */
    height: 80px;
    display: flex;
    justify-content: space-between;
    padding: 0.5rem calc((100vw - 1000px) / 2);
    z-index: 10;
    position: sticky;
    top: 0;

  @media (min-width:1281px) {
    height: 80px;
  }
`


export const Logo = styled.img`
  height:38px;
  width: 38px;
  margin-right: 6px;
`

export const NavLink = styled(Link)`
  color: #209EF1;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;
  &.active {
    color: #15cdfc;
  }
  &:hover{
    color: #5E5E5E;
  }

  #brand{
    color: #209EF1;
    font-weight: bolder;
  }
  /* @media (max-width: 768px){
    #brand{
      color: #209EF1;
    }
  } */
`;


export const NavMenu = styled.div`
  display: flex;
  align-items: center;
  margin-right: 24px;
  @media screen and (max-width: 768px) {
    display: none;
  }
`;


export const NavBtn = styled.nav`
  display: flex;
  align-items: center;
  margin-right: 24px;

 /* Third Nav */
  justify-content: flex-end;
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const NavBtnLink = styled(Link)`
  border-radius: 28px;
  background: #256ce1;
  padding: 10px 18px;
  margin-right: 10px;
  color: #fff;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  /* Second Nav */
  margin-left: 24px;
  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #010606;
  }

`;



export const Bars = styled(FaBars)`
  display: none;
  color: #fff;
  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 75%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`;


export const OverLay = styled.div`
  height: 100%;
  width: ${props => props.width};
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: rgb(0,0,0);
  background-color: rgba(0,0,0, 0.9);
  overflow-x: hidden;
  transition: 0.5s;
`

export const OverLayContent = styled.div`
  position: relative;
  top: 25%;
  /* width: 100%; */
  text-align: center;
  margin-top: 30px;
  display: flex;
  flex-direction: column;

`